"use strict";
/**
 * Created by SH 16/03/2019
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentationManager = void 0;
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const PresentationController_1 = require("./PresentationController");
const SpinEvent_1 = require("../../spin/event/SpinEvent");
class PresentationManager {
    constructor(presentations, checkLogs) {
        this.checkLogs = false;
        this._dataParsed = false;
        this._restoreCalled = false;
        this.presentations = [];
        this.callBack = () => { };
        this.checkLogs = !!checkLogs;
        this.createPresentationControllers(presentations);
    }
    /** Data Checkers **/
    get dataParsed() { return this._dataParsed; }
    get isRestore() { return this._restoreCalled; }
    //------------------------//
    createPresentationControllers(presentations) {
        for (var i = 0; i < presentations.length; i++) {
            this.presentations.push(new PresentationController_1.PresentationController(presentations[i], this.checkLogs));
        }
        this.checkLogs && Logger_1.Logger.log("[PresM]--Presentations created--");
        this.checkLogs && console.log(this.presentations);
    }
    playEvent(type, cb = () => { }) {
        this.setCallback(cb);
        this.checkLogs && Logger_1.Logger.log("[PresM]Trying to find and play Presentations on event " + type);
        const pController = this.presentations.find((pc) => { return pc.isEventList(type); });
        if (pController && pController.findActive()) {
            this.presentation = pController;
            if (!pController.needResult || (pController.needResult && this._dataParsed)) {
                this.tryPlayPresentation();
            }
            return;
        }
        this.activateCallback();
    }
    // To prevent the API endless eventCallback loop. 
    activateAblePresentation(type) {
        var _a;
        return !!((_a = this.presentations.find((pc) => { return pc.isEventList(type); })) === null || _a === void 0 ? void 0 : _a.findActive());
    }
    checkIsActivated(type) {
        var _a;
        return !!((_a = this.presentations.find((pc) => { return pc.isEventList(type); })) === null || _a === void 0 ? void 0 : _a.gotActivePresentation);
    }
    activateCallback() {
        if (this.callBack != undefined) {
            const cb = this.callBack;
            this.callBack = undefined;
            this.checkLogs && Logger_1.Logger.log("[PresM]Event Finished.");
            cb();
        }
    }
    setInitData(data) {
        this._restoreCalled = data.isRestoreState;
        this.presentations.forEach(presentation => { presentation.onInitGameData(data); });
        this.dataIsParsed();
    }
    setGameData(data) {
        this.presentations.forEach(presentation => {
            if (presentation.eventType !== SpinEvent_1.SpinEvent.RESTORE)
                presentation.onGameDataParsed(data);
        });
        this.dataIsParsed();
    }
    dataIsParsed() {
        this._dataParsed = true;
        this.tryPlayPresentation();
    }
    tryPlayPresentation() {
        if (this.presentation) {
            this.checkLogs && Logger_1.Logger.log("[PresM]Fetching a presentation on event: " + this.presentation.eventType);
            this.presentation.Start(() => this.activateCallback());
            this.presentation = null;
        }
    }
    InitPresentations() {
        this.presentations.forEach(p => { p.tryInitialize(); });
        this.checkLogs && Logger_1.Logger.log("[PresM]Presentations has been Initialized.");
    }
    preStart() {
        this._dataParsed = false;
    }
    playEnd(cb = () => { }) {
        this.setCallback(cb);
        this.checkIfEnd();
    }
    checkIfEnd() {
        for (var i = 0; i < this.presentations.length; i++) {
            if (this.presentations[i].findEnding()) {
                this.checkLogs && Logger_1.Logger.log("[PresM]EndPresentation Found on: " + this.presentations[i].eventType);
                this.presentations[i].playEnd(() => this.checkIfEnd());
                return;
            }
        }
        this.activateCallback();
    }
    setCallback(cb) { this.callBack = cb; }
    doSkip() {
        var _a;
        return !!((_a = this.presentations.find((pc) => { return pc.gotActivePresentation; })) === null || _a === void 0 ? void 0 : _a.skip());
    }
}
exports.PresentationManager = PresentationManager;
//# sourceMappingURL=PresentationManager.js.map